// src/components/ProfilKesintiSeridi.tsx
//
// KAPI DARALTMA — serbest bırakılan ekranlarda ZORUNLU şerit.
//
// NEDEN ZORUNLU: kapı daraltılınca profil okunamadığında kullanıcı artık
// tam-ekran "Bağlantı kurulamadı" görmüyor; ekranın kendi içeriğini görüyor.
// Ama ölçümün kendi uyarısı duruyor: "ekran BİR ŞEY render etti" ≠ "DOĞRU
// şeyi render etti". Ekran profil alanlarını sessizce kullanıp eksik veriyle
// dolu görünebilir. Şerit olmadan daraltma, dürüst bir hata ekranını SESSİZ
// bir yanlış-veri ekranıyla değiştirmek olurdu — yanlış-yokluk hatasının
// kardeşi (EMİR #94.3'ün kapattığı sınıf).
//
// 🔒 KAPSAM: kasten minimal ve BLOKLAMAZ. `role="status"` (alert DEĞİL —
// kullanıcının işini kesmiyor), tek satır, tek eylem.
//
// 🧪 TEST KANCASI: `data-vw-degraded` — `data-vw-unreachable`in kardeşi;
// sanal dünya probu "kapı devraldı mı / şerit mi çıktı" ayrımını DOM'dan
// yapabilsin (iz bırakmayan durum ölçülemez).

import React from "react";

interface Props {
  onRetry?: () => void;
  retrying?: boolean;
}

export default function ProfilKesintiSeridi({ onRetry, retrying }: Props) {
  return (
    <div
      data-vw-degraded="1"
      data-vw-retrying={retrying ? "1" : "0"}
      role="status"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "8px 12px",
        fontSize: 13,
        lineHeight: 1.35,
        background: "var(--surface-2, rgba(255,193,7,0.12))",
        color: "var(--text, #262626)",
        borderBottom: "1px solid var(--border, rgba(0,0,0,0.08))",
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 15 }}>
        ⚡
      </span>
      <span style={{ flex: 1, minWidth: 0 }}>
        Bağlantı sorunu var — gördüklerin eksik ya da güncel olmayabilir.
      </span>
      <button
        type="button"
        className="pressable"
        onClick={onRetry}
        disabled={!!retrying}
        aria-busy={retrying ? "true" : "false"}
        style={{
          flex: "0 0 auto",
          padding: "5px 12px",
          borderRadius: 8,
          border: "none",
          fontSize: 12,
          fontWeight: 600,
          background: retrying ? "#7EC4F5" : "#0095F6",
          color: "#fff",
          cursor: retrying ? "default" : "pointer",
        }}
      >
        {retrying ? "Deniyor…" : "Tekrar dene"}
      </button>
    </div>
  );
}
